module.exports = __webpack_public_path__ + "img/fixed.1ba708cb.svg";